module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "copyright"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _vm._v("PUBLISHER’S NOTE: This is a work of fiction. Names, characters, places,"), _c('br'), _vm._v("and incidents are either the product of the author’s imagination or are used"), _c('br'), _vm._v("fictitiously, and any resemblance to actual persons, living or dead, business"), _c('br'), _vm._v("establishments, events, or locales is entirely coincidental.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data"), _c('br'), _vm._v("Skovron, Jon.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Misfit / by Jon Skovron."), _c('br'), _vm._v("p. cm.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Summary: Seattle sixteen-year-old Jael must negotiate normal life in"), _c('br'), _vm._v("Catholic school while learning to control the abilities she inherited from her"), _c('br'), _vm._v("mother, a demon, and protect those she loves from Belial, the Duke of Hell.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("ISBN 978-1-4197-0021-7 (alk. paper)")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("[1. Supernatural — Fiction. 2. Demonology — Fiction. 3. Catholic schools — "), _c('br'), _vm._v("Fiction. 4. High schools — Fiction. 5. Schools — Fiction. 6. Single-parent"), _c('br'), _vm._v("families — Fiction. 7. Seattle (Wash.) — Fiction.] I. Title."), _c('br'), _vm._v("PZ7.S628393Mis 2011"), _c('br'), _vm._v("[Fic] — dc22"), _c('br'), _vm._v("2010048691")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("Text copyright © 2011 Jon Skovron"), _c('br'), _vm._v("Display type design by Sammy Yuen"), _c('br'), _vm._v("Book design by Chad W. Beckerman")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("The text in this book is set in 11.5-point Cochin.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("Published in 2011 by Amulet Books, an imprint of ABRAMS. All"), _c('br'), _vm._v("rights reserved. No portion of this book may be reproduced, stored in a"), _c('br'), _vm._v("retrieval system, or transmitted in any form or by any means, mechanical,"), _c('br'), _vm._v("electronic, photocopying, recording, or otherwise, without written permission"), _c('br'), _vm._v("from the publisher. Amulet Books and Amulet Paperbacks"), _c('br'), _vm._v("are registered trademarks of Harry N. Abrams, Inc.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("Amulet Books are available at special discounts when purchased in quantity"), _c('br'), _vm._v("for premiums and promotions as well as fundraising or educational use."), _c('br'), _vm._v("Special editions can also be created to specification. For details, contact"), _c('br'), _vm._v("specialsales@abramsbooks.com or the address below.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/copyright.jpg"
    }
  }), _c('br'), _vm._v("115 West 18th Street"), _c('br'), _vm._v("New York, NY 10011"), _c('br'), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "http://www.abramsbooks.com",
      "target": "_blank"
    }
  }, [_vm._v("www.abramsbooks.com")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-322dcd54","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/copyright.vue
// module id = 63
// module chunks = 0